'use strict';

angular
	.module('bringgApp')
	.factory('MainNavigationService', function (Authentication, MerchantConfigurations, $location) {
		var MainNavigationService = {};

		MainNavigationService.getFirstAvailableView = function () {
			var currentUser = Authentication.currentUser();
			if (_.isNull(currentUser) || _.isUndefined(currentUser)) {
				return;
			}

			var firstLocation;

			if ($location.search().next_url) {
				var nextUrl = $location.search().next_url;
				$location.search('next_url', undefined);
				return { location: nextUrl };
			}

			if (currentUser.default_welcome_url_id) {
				firstLocation = _.find(MainNavigationService.navbarItems, { id: currentUser.default_welcome_url_id });

				// check in sub locations
				if (!firstLocation) {
					firstLocation = _.chain(MainNavigationService.navbarItems)
						.map('sub_menus')
						.flatten()
						.find({ id: currentUser.default_welcome_url_id })
						.valueOf();
				}
			}
			if (!firstLocation) {
				firstLocation = _.first(
					_.filter(MainNavigationService.navbarItems, MainNavigationService.hasRequiredFeatures)
				);
			}
			return firstLocation;
		};

		MainNavigationService.hasRequiredFeatures = function (navItem) {
			var result = true;
			var currentUser = Authentication.currentUser();

			if (navItem.merchantFeature) {
				result = MerchantConfigurations[navItem.merchantFeature];
			}
			if (result) {
				result = currentUser && currentUser.has_access(navItem.userFeature);
			}

			// hide "main.support" when impersonating
			if (navItem.hideOnImpersonate && currentUser && currentUser.original_user_id) {
				result = false;
			}

			if (navItem.adminRequired && currentUser && !currentUser.admin) {
				result = false;
			}

			return result;
		};

		MainNavigationService.navbarItems = [
			{
				id: 'top_menu_dispatch',
				menuLocation: 'manage',
				userFeature: 'dispatch',
				location: 'present',
				label: 'MAIN.DISPATCH',
				sub_menus: [
					{
						id: 'top_menu_dispatch_map',
						location: 'map'
					},
					{
						id: 'top_menu_dispatch_list',
						location: 'list'
					}
				]
			},
			{
				id: 'top_menu_planning',
				location: 'planning',
				userFeature: 'dispatch',
				merchantFeature: 'planning_phase_exists',
				label: 'MAIN.PLANNING'
			},
			{
				id: 'top_menu_history',
				location: 'history',
				userFeature: 'history',
				label: 'MAIN.HISTORY'
			},
			{
				id: 'top_menu_drivers',
				location: 'drivers',
				userFeature: 'drivers',
				label: 'MAIN.DRIVERS'
			},
			{
				id: 'top_menu_customers',
				location: 'customers',
				userFeature: 'customers_menu',
				label: 'MAIN.CUSTOMERS'
			},
			{
				id: 'top_menu_reports',
				location: 'analytics/reports',
				userFeature: 'reports',
				label: 'MAIN.REPORTS'
			},
			{
				id: 'top_menu_bi_dashboard',
				location: 'bi-dashboard',
				userFeature: 'enable_bi_dashboard',
				merchantFeature: 'enable_bi_dashboard',
				label: 'MAIN.BI_DASHBOARD'
			},
			{
				id: 'top_menu_dashboard',
				location: 'dashboard',
				userFeature: 'dashboard',
				merchantFeature: 'enable_dashboard',
				label: 'MAIN.DASHBOARD'
			},
			{
				id: 'top_menu_support',
				location: 'support',
				userFeature: 'customer_care',
				hideOnImpersonate: true,
				merchantFeature: 'enable_support',
				label: 'MAIN.SUPPORT'
			},
			{
				icon: 'bringg-icon-preparation-restaurant',
				id: 'top_menu_kds',
				location: 'kds',
				merchantFeature: 'enable_kds',
				hideOnImpersonate: false,
				label: 'MAIN.KDS'
			}
		];

		return MainNavigationService;
	});
